import type { ConstValues } from '@openx/types/helpers';

export const requestDirectDealFields = {
  DEAL_TYPE: 'dealType',
  ADVERTISER_BRAND: 'advertiserBrand',
  BUDGET: 'budget',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  TARGETING_DETAILS: 'targetingDetails',
} as const;
export type RequestDirectDealField = ConstValues<typeof requestDirectDealFields>;

export type RequestDirectDealForm = {
  dealType: string;
  advertiserBrand?: string;
  budget?: string;
  startDate?: string | null;
  endDate?: string | null;
  targetingDetails?: string;
};

export type RequestDirectDealPayload = {
  deal_type: string;
  advertiser_brand?: string;
  budget?: string;
  start_date?: string;
  end_date?: string;
  targeting_details?: string;
};
